import type { BorrowMarketRow } from '@/hooks/useBorrowMarkets'
import { useBorrowMarketsSearchState } from '@/hooks/useBorrowMarketsSearchState'
import { cn } from '@/utils/cn'
import { Button } from '../common/button'
import { PlusIcon } from '../icons/plus'
import { BorrowMarketsFilterControls } from './borrowMarketsFilterControls'
import { BorrowMarketsSearchInput } from './borrowMarketsSearchInput'

interface BorrowMarketsFiltersProps {
  borrowMarkets: BorrowMarketRow[]
  numberOfBorrowOptions: number
  className?: string
}

export const BorrowMarketsFilters = ({
  borrowMarkets,
  numberOfBorrowOptions,
  className,
}: BorrowMarketsFiltersProps) => {
  const { touchedParamsCount, clearSearchState } = useBorrowMarketsSearchState()

  return (
    <nav className={cn('flex flex-col gap-3', className)}>
      <div className="flex justify-between gap-3">
        <BorrowMarketsSearchInput
          numberOfBorrowOptions={numberOfBorrowOptions}
          className="flex-grow"
          trackingParams={{ Page: 'Borrow', Device: 'Desktop' }}
        />
        {touchedParamsCount > 0 && (
          <Button
            variant="input"
            size="md"
            title="Clear filters"
            className="fade-in size-10 animate-in px-0"
            onClick={clearSearchState}
          >
            <span className="sr-only">Clear filters</span>
            <PlusIcon size={20} className="rotate-45" />
          </Button>
        )}
      </div>
      <BorrowMarketsFilterControls borrowMarkets={borrowMarkets} />
    </nav>
  )
}
